<template>
  <div class="lgi-box">
    <div class="drop-box">
      <el-dropdown
        @command="changeLanguage"
        style="vertical-align: middle !important"
      >
        <span class="el-dropdown-link">
          <!-- {{ locales }}<i class="el-icon-arrow-down el-icon--right"></i> -->
          {{locales}}
          <!-- <svg
            viewBox="64 64 896 896"
            data-icon="global"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
            class=""
          >
            <path
              d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"
            ></path>
          </svg> -->
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="tw">繁體</el-dropdown-item>
          <el-dropdown-item command="en">English</el-dropdown-item>
          <!-- <el-dropdown-item command="zh">简体</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <div class="flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="9">
          <CCardGroup>
              <CCard class="" style="padding:15px">
                <CCardBody class="">
                    <div style="font-weight:bold;color:#F66C81"><span style="padding-right:2px;word-break:break-all;" class="sition-tip"><i class="el-icon-warning" style="color:#F66C81"></i></span>官方Telegram賬號已恢復，請登入賬戶重新添加官方Telegram客服。</div>
                    <div style="font-weight:bold;color:#F66C81;padding-top:10px;word-break:break-all;"><span style="padding-right:2px" class="sition-tip"><i class="el-icon-warning" style="color:#F66C81"></i></span>另請知悉：FotonCard不會向您索要任何敏感信息（如卡安全碼、有效期、賬戶密碼等），更不會通過社交賬號（包括Telegram）要求您轉賬，請慎防詐騙行爲。</div>
                    <div style="font-weight:bold;color:#F66C81;padding-top:10px;word-break:break-all;"><span style="padding-right:2px" class="sition-tip"><i class="el-icon-warning" style="color:#F66C81"></i></span>The official Telegram account has been restored, please login to the account to add the official Telegram customer service again.</div>
                    <div style="font-weight:bold;color:#F66C81;padding-top:10px;word-break:break-all;"><span style="padding-right:2px" class="sition-tip"><i class="el-icon-warning" style="color:#F66C81"></i></span>Please also be aware that FotonCard WILL NOT ask you for sensitive information (such as card security code, expiration date, account password, etc.), and WILL NOT ask you to transfer money through social accounts (including Telegram), please be careful to prevent fraud.</div>

                    
                </CCardBody>
              </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    </div> -->

    <div class="flex-row align-items-center">
      <CContainer>
        <CRow class="justify-content-center" style="height:100vh;align-items:center">
          <CCol md="9" style="margin-top:10px">
            <CCardGroup>
              <CCard class="p-4" style="padding-bottom:8px !important;">
                <CCardBody>
                  <CForm v-if="!visiReset" style="height:100%">
                    <h3 v-if="isNext" :style="is2Fa || verifyCodeFlag ? 'display: none' : 'display: block'">{{ $t("LoginFields.LoginAccount") }}</h3>
                    <h3 v-if="!isNext">{{ $t("LoginFields.PlaceholderEmail") }}</h3>
                    <h3 v-if="is2Fa">{{ $t("LoginFields.InputCode") }}</h3>
                    <h3 v-if="verifyCodeFlag">{{ $t("LoginFields.InputRecoveryCode") }}</h3>
                    <!-- <p class="text-muted">Sign In to your account</p> -->
                    <CInput
                      v-if="!isNext"
                      :placeholder="$t('LoginFields.PlaceholderEmail')"
                      type="email"
                      prepend="@"
                      autocomplete="username email"
                      v-model="rForm.email"
                      :invalid-feedback="errorBackEmail"
                      :is-valid="validatorEmail"
                      valid-feedback=""
                    >
                      <!-- <template #prepend-content><CIcon name="cil-user"/></template> -->
                    </CInput>
                    <!-- v-if="isNext && !is2Fa" -->
                    <transition-group
                      v-if="isNext && !is2Fa && !verifyCodeFlag"
                      name="animate__animated"
                      appear
                      enter-active-class="animate__animated animate__fadeInLeft"
                      leave-active-class="animate__fadeOutRight"
                    >
                      <CInput
                        key="input"
                        :placeholder="$t('LoginFields.PlacehoderPassword')"
                        type="password"
                        v-model="rForm.password"
                        autocomplete="curent-password"
                      >
                        <template #prepend-content
                          ><CIcon name="cil-lock-locked"
                        /></template>
                      </CInput>
                      <div key="div">
                        <el-alert
                        :title="$t('LoginFields.PasswordOrangeTip')"
                        type="warning"
                        show-icon></el-alert>
                      </div>
                    </transition-group>
                    <!-- 2AF -->
                    <transition-group
                      v-if="is2Fa"
                      name="animate__animated"
                      appear
                      enter-active-class="animate__animated animate__fadeInLeft"
                      leave-active-class="animate__fadeOutRight"
                    >
                      <CRow key="afcode">
                        <CCol md="12" sm="6">
                          <div v-if="is2Fa" style="margin-bottom: .5rem">
                            <el-alert
                              :title="$t('LoginFields.Tips')"
                              type="warning"
                              show-icon
                              center
                            >
                            </el-alert>
                          </div>
                        </CCol>
                        <CCol md="8" sm="6" style="padding-right: 0">
                          
                          <CInput
                            :placeholder="
                              $t('RegisterFields.PlaceholderEmailCode')
                            "
                            autocomplete="username"
                            style="margin-bottom:0"
                            v-model="afcode"
                            key="afcode"
                          >
                            <template #prepend-content
                              ><CIcon name="cil-shield-alt"
                            /></template>
                          </CInput>
                          <CButton @click="visibleVerifyCode" color="link" style="padding-left:0">{{$t('LoginFields.UseRecoveryCode')}}</CButton>
                        </CCol>
                        <CCol md="4">
                          <div>
                            <CButton
                              color="success"
                              style="margin-bottom: 1rem"
                              block
                              @click="req2FaCode"
                              :disabled="dib"
                              >{{ cgan == "" ? getVc : cgan }}</CButton
                            >
                          </div>
                        </CCol>
                      </CRow>
                    </transition-group>
                    <!-- 備用碼 -->
                    <transition-group
                      v-if="verifyCodeFlag"
                      name="animate__animated"
                      appear
                      enter-active-class="animate__animated animate__fadeInLeft"
                      leave-active-class="animate__fadeOutRight"
                    >
                      <CRow key="afcode">
                        <CCol md="12" sm="6">
                          <div v-if="verifyCodeFlag" style="margin-bottom: .5rem">
                            <el-alert
                              :title="$t('LoginFields.Tips')"
                              type="warning"
                              show-icon
                              center
                            >
                            </el-alert>
                          </div>
                        </CCol>
                        <CCol md="8" sm="6" style="padding-right: 0">
                          
                          <CInput
                            :placeholder="
                              $t('LoginFields.RecoveryCode')
                            "
                            autocomplete="username"
                            style="margin-bottom:0"
                            v-model="vCode"
                            key="afcode"
                          >
                            <template #prepend-content
                              ><CIcon name="cil-shield-alt"
                            /></template>
                          </CInput>
                          <CButton @click="visibleVerifyCode2" color="link" style="padding-left:0">{{$t('LoginFields.UseEmailCode')}}</CButton>
                        </CCol>
                      </CRow>
                    </transition-group>

                    <!--  -->
                    <CRow style="height:40px">
                      <CCol col="6" class="text-left" style="display:flex">
                        <el-button
                          v-if="is2Fa"
                          style="background: #321fdb; color: #fff"
                          class="px4"
                          type="submit"
                          native-type="submit"
                          @keyup.enter.native="submit2Fa"
                          @click.native.prevent="submit2Fa($event)"
                          >{{ $t("LoginFields.Login") }}</el-button
                        >
                        <el-button
                          v-if="verifyCodeFlag"
                          style="background: #321fdb; color: #fff"
                          class="px4"
                          type="submit"
                          native-type="submit"
                          @keyup.enter.native="submitRecoveryCode"
                          @click.native.prevent="submitRecoveryCode($event)"
                          >{{ $t("LoginFields.Login") }}</el-button
                        >
                        <!-- {{ $t("LoginFields.Login") }} -->
                        <!-- <CButton
                        v-if="isNext"
                        color="primary"
                        class="px-4"
                        @click="submit"
                      >
                        登錄</CButton
                      > -->
                        <el-button
                          v-if="isNext && !is2Fa && !verifyCodeFlag"
                          style="background: #321fdb; color: #fff"
                          class="px4"
                          type="submit"
                          native-type="submit"
                          @keyup.enter.native="submit"
                          @click.native.prevent="submit($event)"
                          >{{ $t("LoginFields.Login") }}</el-button
                        >
                        <!-- @keyup.enter.native="_LoginEnter('loginEnterData') -->
                        <!-- <CButton
                        v-if="!isNext"
                        :disabled="vaildNext"
                        color="primary"
                        class="px4"
                        @click="toNext($event)"
                        >下一步</CButton
                      > -->
                        <el-button
                          v-if="!isNext"
                          :disabled="vaildNext"
                          style="background: #321fdb; color: #fff;padding:0px 20px"
                          class="px4"
                          native-type="submit"
                          @click.native.prevent="toNext($event)"
                          @keydown="toNextKeyup"
                          >{{ $t("LoginFields.NextStep") }}</el-button
                        >
                        <!-- cibWechat -->
                        <!-- <el-button
                          v-if="!isNext"
                          style="background: #321fdb; color: #fff;padding:0px 20px"
                          class="px4"
                          native-type="button"
                          @click.native.prevent="toWeChatPage()"
                          >
                          
                          <svg style="vertical-align:-7px" t="1662691388626" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5024" width="24" height="24"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" p-id="5025" fill="#fff"></path></svg>
                          {{ $t("LoginFields.WechatScan") }}</el-button
                        > -->
                      </CCol>
                      <CCol style="display:flex;" col="7" class="text-right">
                        <!-- <CButton color="link" class="px-0">Forgot password?</CButton> -->
                        <!-- class="d-lg-none" pc隱藏 -->
                        <!-- <CButton
                          color="link"
                          @click="resetShow"
                          v-if="isNext"
                          >{{ $t("LoginFields.ForgetPassword") }}</CButton
                        >
                        <CButton color="link" @click="toRegister"
                          >{{ $t("LoginFields.RegisterFields") }}!</CButton
                        > -->
                      </CCol>
                    </CRow>
                    <div style="text-align:right;margin-top:50px">
                      <CButton
                          color="link"
                          @click="resetShow"
                          v-if="isNext"
                          >{{ $t("LoginFields.ForgetPassword") }}</CButton
                        >
                        <CButton color="link" @click="toRegister"
                          >{{ $t("LoginFields.RegisterFields") }}!</CButton
                        >
                    </div>
                  </CForm>
                  <!-- 忘記密碼表單 -->

                  <CForm v-if="visiReset">
                    <h3>{{ $t("LoginFields.ResetPassword") }}</h3>
                    <CInput
                      :placeholder="$t('LoginFields.NewPassword')"
                      type="password"
                      v-model="rForm.password"
                      autocomplete="curent-password"
                      :invalid-feedback="errorBackPassword"
                      :is-valid="validatorPassword"
                      valid-feedback=""
                    >
                      <template #prepend-content
                        ><CIcon name="cil-lock-locked"
                      /></template>
                    </CInput>
                    <CInput
                      :placeholder="$t('LoginFields.ConfirmPassword')"
                      type="password"
                      v-model="resetForm.cfPassword"
                      autocomplete="curent-password"
                      :invalid-feedback="errorBackConfirm"
                      :is-valid="validatorConfirm"
                      valid-feedback=""
                    >
                      <template #prepend-content
                        ><CIcon name="cil-lock-locked"
                      /></template>
                    </CInput>
                    <CRow>
                      <CCol md="8" sm="6" style="padding-right: 0">
                        <CInput
                          :placeholder="
                            $t('RegisterFields.PlaceholderEmailCode')
                          "
                          autocomplete="username"
                          v-model="resetForm.code"
                        >
                          <template #prepend-content
                            ><CIcon name="cil-shield-alt"
                          /></template>
                        </CInput>
                      </CCol>
                      <CCol md="4">
                        <div>
                          <CButton
                            color="success"
                            style="margin-bottom: 1rem"
                            block
                            @click="reqCode"
                            :disabled="dib"
                            >{{ cgan == "" ? getVc : cgan }}</CButton
                          >
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol col="6" class="text-left">
                        <el-button
                          style="background: #321fdb; color: #fff"
                          class="px4"
                          type="submit"
                          native-type="submit"
                          @keyup.enter.native="reset"
                          @click.native.prevent="reset($event)"
                          >{{ $t("LoginFields.ComfirmAndSignIn") }}</el-button
                        >
                      </CCol>
                      <CCol col="6" class="text-right" key="2">
                        <!-- <CButton color="link" @click="subShow">登入</CButton> -->
                        <!-- <CButton color="link" @click="toRegister">{{ $t('LoginFields.RegisterFields') }}!</CButton> -->
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                color="primary"
                text-color="white"
                class="text-center py-5 d-md-down-none"
                body-wrapper
              >
                <CCardBody>
                  <h2>Foton Card</h2>
                  <p style="margin: 0 20px">
                    {{ $t("LoginFields.FotonCardInfo") }}
                  </p>
                  <p style="margin-top: 1rem">
                    <a href="mailto:info@fotoncard.com" style="color: #fff" target="_blank">{{ $t('LoginFields.Welcome') }}</a>
                  </p>
                  <!-- <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                  @click="toRegister"
                >
                  Register Now!
                </CButton> -->
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import request from "../../api/request";
import { mapMutations } from "vuex";
import {changeLanguages,twofaRecoveryCode,loginCheckUserName,login} from "../../api/http"
export default {
  name: "Login",
  data() {
    return {
      rForm: {
        email: "",
        password: "",
      },
      resetForm: {
        newPassword: "",
        cfPassword: "",
        code: null,
      },
      isNext: false,
      errorBackEmail: "",
      vaildNext: true,
      visiReset: false,
      timer: null,
      dib: false,
      timerNum: 60,
      cgan: "",
      errorBackConfirm: "",
      errorBackPassword: "",
      cookie: "",
      afcode: null,
      is2Fa: false,
      ips: "",
      // 備用碼顯示
      verifyCodeFlag: false,
      vCode: null
    };
  },
  watch: {
    ips: {
      handler(val) {
        // window.sessionStorage.getItem("ipname") 
        console.log("ip val ==>", val);
        if (val == "国内未能识别的地区") {
          // 请求翻译接口
          setTimeout(() => {
            let obj = {
            type: "change_language",
            lan: "EN",
          };
          changeLanguages(obj).then((res) => {
            // console.log("lange res==>", res)
            if (res.code == 200) {
              window.localStorage.setItem("lang", "en");
              this.$i18n.locale = "en";
            } else {
              this.$message.error(res.message);
            }
          });
          }, 2000)
        } else {
          console.log("ip true");
        }
      },
    },
  },
  computed: {
    getVc: {
      get() {
        return this.$t("RegisterFields.SendCode2");
      },
      set(v) {
        console.log("vvv==>", v);
        this.cgan = v;
      },
    },
    // 国际化切换显示对应文字
    locales() {
      let language = localStorage.getItem('admin_lang')
      if(language == 'TC') {
        this.$i18n.locale == "tw"
        return '繁體'
      } else if(language == 'EN') {
        this.$i18n.locale == "en"
        return 'EN'
      }else{
        this.$i18n.locale == "en"
        return 'EN'
      }
      // if (this.$i18n.locale == "tw") {
      //   return "繁体";
      // } else if (this.$i18n.locale == "zh") {
      //   return "中文";
      // } else {
      //   return "EN";
      // }
    },
  },
  methods: {
    toWeChatPage() {
      console.log('totototo')
      this.$router.push("/pages/wechat-login");
    },
    // 點擊使用備用碼
    visibleVerifyCode() {
      this.verifyCodeFlag = true
      this.is2Fa = false
    },
    visibleVerifyCode2() {
      this.is2Fa = true
      this.verifyCodeFlag = false
    },
    // 随机数
    randomString(e) {
      e = e || 24;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456789",
        a = t.length,
        n = "";
      for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
    ...mapMutations(["setUserInfo"]),
    resetShow() {
      this.visiReset = true;
    },
    subShow() {
      this.visiReset = false;
    },
    // 请求重置密码的验证码
    reqCode() {
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "get_email_code",
        code_type: "reset_pw",
        user_name: this.rForm.email,
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: "https://test.fotoncard.com/request/user.php",
        data: formData,
      }).then((code) => {
        console.log("req code==>", code)
        if(code.data.code == undefined) {
          this.$message.error(code.data);
          loading.close();
        }
        if (code.data.code == 200) {
          loading.close();
          this.$message.success(code.data.message);
          this.cellCode();
        } else {
          this.timerNum = 0;
          clearInterval(this.timer);
          this.$message.error(code.data.message);
        }
      }).catch((err) => {
        console.log("err=>", err)
        this.$message.error(err);
      })
    },
    // 请求2fa的验证码
    req2FaCode() {
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "get_email_code",
        code_type: "2fa",
        user_name: this.rForm.email,
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: "https://test.fotoncard.com/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          loading.close();
          // this.$message.success(code.data.message);
          this.cellCode();
        } else {
          this.timerNum = 0;
          clearInterval(this.timer);
          this.$message.error(code.data.message);
        }
      });
    },
    // 请求验证码倒计时
    cellCode() {
      // this.reqCode()
      this.dib = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timerNum--;
        // this.vcode = this.timerNum
        this.getVc = this.timerNum;
        // this.$t('RegisterFields.SendCode2') = this.timerNum
        if (this.timerNum == 0) {
          clearInterval(this.timer);
          // this.vcode = this.rcode
          //  this.vcode = this.$t('RegisterFields.SendCode')
          // this.vcode = this.getVc
          this.timerNum = 60;
          this.dib = false;
        }
      }, 1000);
    },
    // 提交備用碼
    submitRecoveryCode() {
      if(this.vCode == null || this.vCode == '') {
        return
      }
      this.setCookie("ckey", this.cookie)
      let data = {
        type: '2fa_recovery_code',
        user_name: this.rForm.email,
        login_cookie: this.getCookie("ckey"),
        recovery_code: this.vCode
      }
      twofaRecoveryCode(data).then((res) => {
        if(res.code == 200) {
          this.submit()
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 2Fa提交
    submit2Fa() {
      this.setCookie("ckey", this.cookie)
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "2fa_athentication",
        login_cookie: this.getCookie("ckey"),
        user_name: this.rForm.email,
        email_code: this.afcode,
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: "https://test.fotoncard.com/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          loading.close();
          this.$message.success(code.data.message);
          this.submit();
        } else {
          loading.close();
          this.$message.error(code.data.message);
        }
      });
    },
    // 验证确认密码
    validatorConfirm(val) {
      if (val === "") {
        this.errorBackConfirm = "";
        return;
      }
      if (val !== this.rForm.password) {
        this.errorBackConfirm = this.$t("RegisterFields.CRPTip");
        return false;
      }
      this.errorBackConfirm = "";
      return true;
    },
    // 密码验证
    validatorPassword(val) {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      if (val === "") {
        this.errorBackPassword = "";
        return;
      }
      if (reg.test(val)) {
        this.errorBackPassword = "";
        return true;
      } else {
        this.errorBackPassword = this.$t("RegisterFields.PasswordTip");
        return false;
      }
    },
    // 重置密码
    reset() {
      this.setCookie("ckey", this.cookie);
      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "reset_password",
        user_name: this.rForm.email,
        new_password: this.rForm.password,
        email_code: this.resetForm.code,
        login_cookie: this.getCookie("ckey"),
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        data: formData,
      }).then((res) => {
        console.log('abc==>', res)
        if (res.data.code == 200) {
          loading.close();
          this.submit();
        } else {
          loading.close();
          this.$message.error(res.data.message);
        }
      });
    },
    // 获取语言并且设置语言
    changeLanguage(e) {
      let str = ""
      if(e == "tw") {
        str = e.replace(e, "TC")
      }else {
        str = e.replace(e, "EN")
      }
      console.log('lange==>', str)
      let obj = {
        type: "change_language",
        lan: str
      }
      changeLanguages(obj).then((res) => {
        // console.log("lange res==>", res)
        if(res.code == 200) {
          window.localStorage.setItem("admin_lang", e == 'tw' ? 'TC' : 'EN');
          this.$i18n.locale = e;
          window.location.reload()
        }else{
          this.$message.error(res.message)
        }
      })
      // let str = ""
      // if(e == "tw") {
      //   str = e.replace(e, "TC")
      // }else {
      //   str = e.replace(e, "EN")
      // }
      // console.log('lange==>', str)
      // let obj = {
      //   type: "change_language",
      //   lan: str
      // }
      // changeLanguages(obj).then((res) => {
      //   // console.log("lange res==>", res)
      //   if(res.code == 200) {
      //     window.localStorage.setItem("lang", e);
      //     this.$i18n.locale = e;
      //     window.location.reload()
      //   }else{
      //     this.$message.error(res.message)
      //   }
      // })
      // location.reload();
      // window.localStorage.setItem("lang", e);
      // this.$i18n.locale = e;
    },
    toRegister() {
      console.log("222");
      this.$router.push("/pages/register");
    },
    // 下一步
    toNext(e) {
      console.log("ee", e);

      let loading = Loading.service({ fullscreen: true });
      if (this.rForm.email == "") {
        this.$message.error(this.$t("RegisterFields.None"));
        loading.close();
        return;
      }
      let obj = {
        type: "login_check_user_name",
        user_name: this.rForm.email,
      };
      // loginCheckUserName(obj).then((res) => {
      //   if(res.code == 200) {
      //     this.isNext = true
      //   }else{
      //     this.$message.error(res.message)
      //     this.isNext = false
      //     this.vaildNext = false
      //   }
      // }).catch((e) => {
      //   console.log('err==>', e)
      // })
      let formData = new FormData();
      for (let it in obj) {
        formData.append(it, obj[it]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: "https://test.fotoncard.com/request/user.php",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // headers: {Authorization: 'Bearer ' + token},
        data: formData,
      })
        .then((res) => {
          if (res.data.code == 200) {
            loading.close();
            this.isNext = true;
          } else {
            loading.close();
            this.$message.error(res.data.message);
            this.isNext = false;
            this.vaildNext = false;
            console.log("res==>", res);
          }
        })
        .catch((err) => {
          console.log("err==>", err);
        });
    },
    // 验证邮箱
    validatorEmail(val) {
      // let reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val === "") {
        this.errorBackEmail = "";
        return;
      }
      if (reg.test(val)) {
        this.errorBackEmail = "";
        this.vaildNext = false;
        return true;
      } else {
        this.errorBackEmail = this.$t("RegisterFields.CETip");
        return false;
      }
    },
    toLogin() {
      //其他的校验逻辑

      //...

      //获取未登录的时候跳到登录页面的redirect地址

      const redirect = this.$route.query.redirect;

      if (redirect) {
        //存在回跳地址就回跳

        this.$router.push(redirect);
      } else {
        //否则就跳到默认的首页

        this.$router.push({
          name: "Dashboard",
        });
      }
    },
    // 登入
    submit() {
      if (this.rForm.password == "") {
        this.$message.error(this.$t("RegisterFields.None"));
        return;
      }

      let loading = Loading.service({ fullscreen: true });
      let data = {
        type: "login",
        user_name: this.rForm.email,
        password: this.rForm.password,
        login_cookie: this.getCookie("ckey"),
      };
      // login(data).then((res) => {
      //     if (res.code == 200) {
      //     loading.close();
      //     window.localStorage.setItem("login_cookie", this.randomString(24));
      //     sessionStorage.setItem("isLogin", 1);
      //     // this.$router.push("/dashboard")
      //     this.$message.success(res.message);
      //     // sessionStorage.setItem("uid", res.data.data.id)
      //     // this.setUserInfo(res.data.data)
      //     this.$store.commit("setUserInfo", res.data);

      //     const uid = res.data.map((item) => item.id);
      //     const user_name = res.data.map((item) => item.user_name);
      //     const is_agent = res.data.map((item) => item.is_agent)

      //     // window.sessionStorage.setItem("uid", uid)
      //     window.localStorage.setItem("uid", uid);
      //     window.localStorage.setItem("user_name", user_name);
      //     window.localStorage.setItem("is_agent", is_agent)
      //     // this.$i18n.locale = 'tw'

      //     this.$router.push({ path: "/dashboard" });
      //   } else if (res.code == 100) {
      //     this.is2Fa = true;
      //     this.req2FaCode();
      //     loading.close();
      //     this.$message.warning(res.message);
      //   } else {
      //     loading.close();
      //     this.$message.error(res.message);
      //   }
      // })
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: "https://test.fotoncard.com/request/user.php",
        data: formData,
      }).then((res) => {
        if (res.data.code == 200) {
          loading.close();
          window.localStorage.setItem("login_cookie", this.randomString(24));
          sessionStorage.setItem("isLogin", 1);
          localStorage.setItem("admin_lang", res.data.data[0].language);
          this.$i18n.locale = res.data.data[0].language == 'TC' ? 'tw' : 'en'
          // this.$router.push("/dashboard")
          // this.$message.success(res.data.message);
          // sessionStorage.setItem("uid", res.data.data.id)
          // this.setUserInfo(res.data.data)
          this.$store.commit("setUserInfo", res.data.data);

          const uid = res.data.data.map((item) => item.id);
          const user_name = res.data.data.map((item) => item.user_name);
          const is_agent = res.data.data.map((item) => item.is_agent)

          // window.sessionStorage.setItem("uid", uid)
          window.localStorage.setItem("uid", uid);
          window.localStorage.setItem("user_name", user_name);
          window.localStorage.setItem("is_agent", is_agent)
          // this.$i18n.locale = 'tw'
          this.$store.dispatch('openTimeTask', uid)

          this.$router.push({ path: "/dashboard" });
        } else if (res.data.code == 100) {
          this.is2Fa = true;
          this.req2FaCode();
          loading.close();
          this.$message.warning(res.data.message);
        } else {
          loading.close();
          this.$message.error(res.data.message);
        }
      });
    },
    setKeyCode() {
      let _self = this;
      let key;
      document.onkeydown = function (e) {
        if (window.event === undefined) {
          key = e.keyCode;
        } else {
          key = window.event.keyCode;
        }
        if (key === 13) {
          _self.nextLoginEnter("loginEnter");
          _self._LoginEnter("loginEnterData");
        }
      };
    },
    nextLoginEnter(e) {
      if (e === "loginEnter") {
        this.toNext();
        return;
      }
    },
    _LoginEnter(e) {
      if (e === "loginEnterData") {
        this.submit();
        return;
      }
    },
    toNextKeyup(e) {
      console.log("key==>", e);
    },
    // 读取cookie
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      // else return null;
      //  else return this.setCookie("ckey", this.cookie)
      else return "";
      // else{
      //   console.log('cookie none')
      //   this.setCookie("ckey", this.cookie)
      // }
    },
    // 写入cookie
    setCookie(name, value) {
      var Days = 30;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
  },
  created() {
    this.ips = window.sessionStorage.getItem("ipname")
    // this.toLogin()
    // this.setKeyCode()
    // console.log(this.randomString(24))
    this.cookie = this.randomString(24);
    // this.setCookie("ckey", this.cookie)
    // window.localStorage.setItem("cookie", this.cookie);

    // console.log("cookie", this.getCookie("ckey"))
  },
};
</script>
<style scoped>
.drop-box {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 2rem;
  margin-top: 1rem;
}
.sition-tip{
  opacity: 1;
  animation: div_animate .5s forwards 1s alternate infinite;
}
@keyframes div_animate{
  from{
    opacity: 1;
  }
  to{
    opacity: 0;
  }
}

</style>
